export const images1 = [
    {
      id: 1,
      url: "https://eimkeia.stripocdn.email/content/guids/CABINET_8270216c780e362a1fbcd636b59c67ae376eb446dc5f95e17700b638b8c3f618/images/image_22.png",
    },
    {
      id: 2,
      url: "https://eimkeia.stripocdn.email/content/guids/CABINET_8270216c780e362a1fbcd636b59c67ae376eb446dc5f95e17700b638b8c3f618/images/hul.png",
    },
    {
      id: 3,
      url: "https://eimkeia.stripocdn.email/content/guids/CABINET_8270216c780e362a1fbcd636b59c67ae376eb446dc5f95e17700b638b8c3f618/images/hul_2.png",
    },
    {
      id: 4,
      url: "https://eimkeia.stripocdn.email/content/guids/CABINET_8270216c780e362a1fbcd636b59c67ae376eb446dc5f95e17700b638b8c3f618/images/hul_3.png",
    },
    {
      id: 5,
      url: "https://eimkeia.stripocdn.email/content/guids/CABINET_8270216c780e362a1fbcd636b59c67ae376eb446dc5f95e17700b638b8c3f618/images/hul_4.png",
    },
    {
      id: 6,
      url: "https://eimkeia.stripocdn.email/content/guids/CABINET_8270216c780e362a1fbcd636b59c67ae376eb446dc5f95e17700b638b8c3f618/images/hul_5.png",
    },
  ];

  export const images2 = [
    {
      id: 1,
      url: "https://eimkeia.stripocdn.email/content/guids/CABINET_8270216c780e362a1fbcd636b59c67ae376eb446dc5f95e17700b638b8c3f618/images/hul_6.png",
    },
    {
      id: 2,
      url: "https://eimkeia.stripocdn.email/content/guids/CABINET_8270216c780e362a1fbcd636b59c67ae376eb446dc5f95e17700b638b8c3f618/images/hul_8.png",
    },
    {
      id: 3,
      url: "https://eimkeia.stripocdn.email/content/guids/CABINET_8270216c780e362a1fbcd636b59c67ae376eb446dc5f95e17700b638b8c3f618/images/comfortfabricconditionerremovebgpreview.png",
    },
    {
      id: 4,
      url: "https://eimkeia.stripocdn.email/content/guids/CABINET_8270216c780e362a1fbcd636b59c67ae376eb446dc5f95e17700b638b8c3f618/images/510wnj0cxtl_sl1000_removebgpreview_1.png",
    },
    {
      id: 5,
      url: "https://eimkeia.stripocdn.email/content/guids/CABINET_8270216c780e362a1fbcd636b59c67ae376eb446dc5f95e17700b638b8c3f618/images/51d3ux9kygl_sl1000_removebgpreview_1.png",
    },
  ];